import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6 mb-lg-0 mb-2" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "button-header text-lg-right upload-btn-wrap" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Create ")
const _hoisted_8 = { class: "btn default-btn d-inline-block mr-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-cogs" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" File Tag Settings ")
const _hoisted_13 = {
  key: 0,
  class: "breadcrumb-wrap"
}
const _hoisted_14 = { "aria-label": "breadcrumb" }
const _hoisted_15 = { class: "breadcrumb" }
const _hoisted_16 = { class: "breadcrumb-item" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Upload Files ")
const _hoisted_20 = /*#__PURE__*/_createVNode("h5", null, "FOLDERS", -1)
const _hoisted_21 = {
  key: 2,
  class: "row my-3 mx-n2"
}
const _hoisted_22 = {
  key: 3,
  class: "empty-channel bg-white p-3 mb-3 text-center"
}
const _hoisted_23 = { class: "sticky-header sticky-md-top mb-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", {
  id: "filesInMyDrive",
  class: "d-inline-block mr-3 mb-0"
}, "FILES", -1)
const _hoisted_25 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode()
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "hover-text" }, "Delete", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fa fa-share-alt" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode()
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "hover-text" }, "Share", -1)
const _hoisted_32 = {
  key: 5,
  class: "empty-channel bg-white p-3 mb-3 text-center"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-wrap default-modal\"><div class=\"modal fade\" id=\"detailModal\" tabindex=\"-1\" aria-labelledby=\"detailModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"iconed-block-list\"><ul><li><span class=\"icon-wrap\"><i class=\"fa fa-folder\"></i></span><h5>Untitled Folder</h5></li></ul></div><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><div class=\"ck-file-details\"><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Type</p></div><div class=\"col-sm-9 px-md-1\"><p>Folder</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Size</p></div><div class=\"col-sm-9 px-md-1\"><p>35.48 MB</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Owner</p></div><div class=\"col-sm-9 px-md-1\"><p>Me</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Shared with</p></div><div class=\"col-sm-9 px-md-1\"><div class=\"user-avatar xs\"><img src=\"https://lh3.googleusercontent.com/a-/AOh14Gg6GsVjMGcxlUEiwds4XFTfTXUSZ1DXJ6JP3G2PLg=s96-c\" alt=\"\"></div><div class=\"user-avatar xs\"><img src=\"https://lh3.googleusercontent.com/a-/AOh14Gg6GsVjMGcxlUEiwds4XFTfTXUSZ1DXJ6JP3G2PLg=s96-c\" alt=\"\"></div><div class=\"user-avatar xs\"><img src=\"https://lh3.googleusercontent.com/a-/AOh14Gg6GsVjMGcxlUEiwds4XFTfTXUSZ1DXJ6JP3G2PLg=s96-c\" alt=\"\"></div></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Modified</p></div><div class=\"col-sm-9 px-md-1\"><p>Feb 19, 2020 by Abu Bit Istiyak</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Opened</p></div><div class=\"col-sm-9 px-md-1\"><p>Apr 23, 2020 by Me</p></div></div><div class=\"row mx-sm-n1 mb-2\"><div class=\"col-sm-3 px-md-1\"><p>Created</p></div><div class=\"col-sm-9 px-md-1\"><p>Feb 19, 2020</p></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn default-btn\">Share</button><button type=\"button\" class=\"btn secondary-btn\">Download</button></div></div></div></div></div><div class=\"modal-wrap default-modal\"><div class=\"modal fade\" id=\"shareModal\" tabindex=\"-1\" aria-labelledby=\"shareModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"iconed-block-list\"><ul><li><span class=\"icon-wrap\"><i class=\"fa fa-folder\"></i></span><h5>Untitled Folder</h5></li></ul></div><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><div class=\"form-wrap\"><div class=\"form-group\"><label for=\"exampleInputEmail1\">Project</label><select class=\"form-control\"><option value=\"\">Project Name</option><option value=\"\">Project Name</option><option value=\"\">Project Name</option></select></div><div class=\"form-group\"><label for=\"exampleInputEmail1\">Channel</label><select class=\"form-control\"><option value=\"\">Channel Name</option><option value=\"\">Channel Name</option><option value=\"\">Channel Name</option></select></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn default-btn\">Share</button><button type=\"button\" class=\"btn secondary-btn\" data-dismiss=\"modal\"> Close </button></div></div></div></div></div><div class=\"modal-wrap default-modal\"><div class=\"modal fade\" id=\"copyModal\" tabindex=\"-1\" aria-labelledby=\"copyModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><p class=\"text-success\"><i class=\"far fa-check-circle mr-2\"></i><strong>Link copied.</strong> Allows viewing. </p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"https://www.dropbox.com/s/11ydxpibqs2c5cr/01-Homepage-01.jpg?dl=0\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn default-btn\">Copy</button><button type=\"button\" class=\"btn secondary-btn\" data-dismiss=\"modal\"> Close </button></div></div></div></div></div>", 3)
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "modal-wrap default-modal" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "modal fade",
    id: "deleteModal",
    tabindex: "-1",
    "aria-labelledby": "deleteModalLabel",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createVNode("div", { class: "modal-dialog modal-dialog-centered modal-sm" }, [
      /*#__PURE__*/_createVNode("div", { class: "modal-content" }, [
        /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
          /*#__PURE__*/_createVNode("h5", {
            class: "modal-title",
            id: "renameModalLabel"
          }, "Delete"),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, [
            /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
          /*#__PURE__*/_createVNode("div", {
            class: "alert alert-danger mb-0",
            role: "alert"
          }, " Are you sure? You want to delete. ")
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn default-btn"
          }, "Ok"),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn secondary-btn",
            "data-dismiss": "modal"
          }, " Close ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_37 = { class: "modal-wrap default-modal" }
const _hoisted_38 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createSubFolder",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_39 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "modal-header" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Create Folder "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Folders are where your structure your files. ")
], -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "form-wrap pt-0" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Folder name", -1)
const _hoisted_48 = { class: "modal-footer" }
const _hoisted_49 = { class: "modal-wrap default-modal" }
const _hoisted_50 = {
  class: "modal fade",
  id: "namerename",
  tabindex: "-1",
  "aria-labelledby": "namerenameLabel",
  "aria-hidden": "true"
}
const _hoisted_51 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_52 = { class: "modal-content" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "namerenameLabel"
  }, "Rename File"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = { class: "form-group mb-0" }
const _hoisted_56 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyDriveFileSearch = _resolveComponent("MyDriveFileSearch")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_MyDriveFilesUpload = _resolveComponent("MyDriveFilesUpload")
  const _component_MyDriveFolder = _resolveComponent("MyDriveFolder")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_MyDriveFile = _resolveComponent("MyDriveFile")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ShareModal = _resolveComponent("ShareModal")
  const _component_DeleteSelectedModal = _resolveComponent("DeleteSelectedModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_MyDriveFileSearch, {
              onFolderList: _ctx.searchFolderList,
              onErrorList: _ctx.searchErrorList,
              onHasError: _ctx.searchHasError,
              onSearchByTag: _ctx.searchByTag,
              folerId: _ctx.state.data.folderId
            }, null, 8, ["onFolderList", "onErrorList", "onHasError", "onSearchByTag", "folerId"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                class: "btn default-btn outline d-inline-block mr-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCreateFolder && _ctx.showCreateFolder(...args)))
              }, [
                _hoisted_6,
                _hoisted_7
              ]),
              _createVNode("button", _hoisted_8, [
                _createVNode("input", {
                  type: "file",
                  multiple: "",
                  accept: "*.*",
                  id: "create-document-upload",
                  class: "custom-file-input",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDocumentChange($event)))
                }, null, 32),
                _hoisted_9,
                _hoisted_10
              ]),
              _createVNode("button", {
                class: "btn default-btn outline d-inline-block mr-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToFileTagSettings && _ctx.redirectToFileTagSettings(...args)))
              }, [
                _hoisted_11,
                _hoisted_12
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.folderList &&
              _ctx.state.data.folderList.breadcrumbs &&
              _ctx.state.data.folderList.breadcrumbs.length
              )
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode("nav", _hoisted_14, [
              _createVNode("ol", _hoisted_15, [
                _createVNode("li", _hoisted_16, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectingToMyDrive && _ctx.redirectingToMyDrive(...args)))
                  }, "My Drive")
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.folderList.breadcrumbs, (state, stateIndex) => {
                  return (_openBlock(), _createBlock("li", {
                    class: _ctx.folderActive === stateIndex
                ? 'breadcrumb-item active'
                : 'breadcrumb-item'
              ,
                    "aria-current": "page",
                    key: stateIndex
                  }, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.redirectToSelectedFolder(state)),
                      class: _ctx.folderActive === stateIndex
                ? 'breadcrumb-item active'
                : 'breadcrumb-item'
              
                    }, _toDisplayString(state.folder_name), 11, ["onClick"])
                  ], 2))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DragAndDropZone, {
        onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
        onDropFiles: _ctx.dropFiles
      }, null, 8, ["onDrop", "onDropFiles"]),
      (_ctx.state.data.imagesToUpload && _ctx.state.data.imagesToUpload.length)
        ? (_openBlock(), _createBlock(_component_MyDriveFilesUpload, {
            key: 1,
            imageList: _ctx.state.data.imagesToUpload,
            onUploadImage: _ctx.getReadyImageListToUpload,
            onLatestEnabledTags: _ctx.latestEnabledTags,
            onRemoveSelectedImage: _ctx.removeSelectedImage,
            onOpenModal: _ctx.openRenameModal
          }, null, 8, ["imageList", "onUploadImage", "onLatestEnabledTags", "onRemoveSelectedImage", "onOpenModal"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_17, [
        (_ctx.state.data.imagesToUpload && _ctx.state.data.imagesToUpload.length)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "btn default-btn d-inline-block",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
            }, [
              _hoisted_18,
              _hoisted_19
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_20,
      (_ctx.state.data.folderList &&
              _ctx.state.data.folderList.folders &&
              _ctx.state.data.folderList.folders.length
              )
        ? (_openBlock(), _createBlock("div", _hoisted_21, [
            _createVNode(_component_MyDriveFolder, {
              folders: _ctx.state.data.folderList.folders,
              onDelete: _ctx.deleteSelectedFolder,
              onRename: _ctx.renameSelectedFolder
            }, null, 8, ["folders", "onDelete", "onRename"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_22, [
            _createVNode(_component_EmptyData, {
              title: _ctx.state.data.folderTitle,
              heading: _ctx.state.data.folderHeading
            }, null, 8, ["title", "heading"])
          ])),
      _createVNode("div", _hoisted_23, [
        _hoisted_24,
        (_ctx.state.data.selectedFiles && _ctx.state.data.selectedFiles.length)
          ? (_openBlock(), _createBlock("span", _hoisted_25, [
              _createVNode("a", {
                class: "round-icon red-btn  mx-2 p-0",
                href: "javascript:void(0)",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showDeleteSelectedModal && _ctx.showDeleteSelectedModal(...args)))
              }, [
                _hoisted_26,
                _hoisted_27,
                _hoisted_28
              ]),
              _createVNode("a", {
                class: "round-icon black-btn mx-2 p-0",
                href: "javascript:void(0)",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showShareModal && _ctx.showShareModal(...args)))
              }, [
                _hoisted_29,
                _hoisted_30,
                _hoisted_31
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.state.data.folderList.files && _ctx.state.data.folderList.files.length)
        ? (_openBlock(), _createBlock(_component_MyDriveFile, {
            key: 4,
            files: _ctx.state.data.folderList.files,
            onRename: _ctx.closeRenameFileModal,
            onDeleteFile: _ctx.deleteSelectedFile,
            onSelectedFile: _ctx.checkedSelctedFile,
            onTagUpdate: _ctx.updateFileTag
          }, null, 8, ["files", "onRename", "onDeleteFile", "onSelectedFile", "onTagUpdate"]))
        : (_openBlock(), _createBlock("div", _hoisted_32, [
            _createVNode(_component_EmptyData, {
              title: _ctx.state.data.fileTitle,
              heading: _ctx.state.data.fileHeading
            }, null, 8, ["title", "heading"])
          ])),
      _hoisted_33,
      _hoisted_36,
      _createVNode("div", _hoisted_37, [
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, [
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideCreateFolder && _ctx.hideCreateFolder(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_43
                ])
              ]),
              _createVNode("div", _hoisted_44, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.error.errorList.createNewFolder,
                  hasError: _ctx.state.ui.error.hasError
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _withDirectives(_createVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "exampleInputFolderName",
                      "aria-describedby": "emailHelp",
                      placeholder: "eg.Team",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.folderName = $event)),
                      onKeydown: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.createNewFolder && _ctx.createNewFolder(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.data.folderName]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_48, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.createNewFolder && _ctx.createNewFolder(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.createNewFolder
                ? "Creating..."
                : "Create Folder"), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 6,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true),
      (_ctx.state.data.showShareModal)
        ? (_openBlock(), _createBlock(_component_ShareModal, {
            key: 7,
            showModal: _ctx.state.data.showShareModal,
            selectedFiles: _ctx.state.data.selectedFiles,
            onClose: _ctx.closeShareModal
          }, null, 8, ["showModal", "selectedFiles", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.state.data.showDeleteModal)
        ? (_openBlock(), _createBlock(_component_DeleteSelectedModal, {
            key: 8,
            onClose: _ctx.closeDeleteMultipleModal,
            showModal: _ctx.state.data.showDeleteModal,
            selectedFiles: _ctx.state.data.selectedFiles
          }, null, 8, ["onClose", "showModal", "selectedFiles"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_49, [
      _createVNode("div", _hoisted_50, [
        _createVNode("div", _hoisted_51, [
          _createVNode("div", _hoisted_52, [
            _hoisted_53,
            _createVNode("div", _hoisted_54, [
              _createVNode("div", _hoisted_55, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.selectedFileName = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.selectedFileName]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_56, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveFileName && _ctx.saveFileName(...args)))
              }, "Save changes")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}